import fetchClient from './fetchClient';

import { errorHandler } from "./utils";


const config = () => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    };
};

export const markTaskAsDone = async (id: string) => {
    const res = await fetchClient
        .put(`/tasks/${id}/done`, {}, config())
        .catch(errorHandler);
    return res.data;
};

export const rescheduleTask = async (id: string, dueDate: string) => {
    const res = await fetchClient
        .put(`/tasks/${id}/reschedule`, { dueDate }, config())
        .catch(errorHandler);
    return res.data;
};

export const getMyTasks = async () => {
    const res: any = await fetchClient.get("/tasks", config()).catch((): null => {
        return null;
    });
    if (!res) return null;
    return res.data;
}

export const getTodayTasks = async (userId?: string) => {
    const url = userId ? `/tasks/today?userId=${userId}` : "/tasks/today";
    const res: any = await fetchClient.get(url, config()).catch((): null => {
        return null;
    });
    if (!res) return null;
    return res.data;
}

export const getAllTasks = async (userId?: string) => {
    const url = userId ? `/tasks/all?userId=${userId}` : "/tasks/all";
    const res: any = await fetchClient.get(url, config()).catch((): null => {
        return null;
    });
    if (!res) return null;
    return res.data;
}